module.exports = __webpack_public_path__ + "media/hyper/images/payments/citi-ae3a0e3d81fc83d8d74c78e1335c94d9.png";